import { render, staticRenderFns } from "./objectList.vue?vue&type=template&id=0f666ed4&"
import script from "./objectList.vue?vue&type=script&lang=ts&"
export * from "./objectList.vue?vue&type=script&lang=ts&"
import style0 from "./objectList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports